import { render, staticRenderFns } from "./selectRooms.vue?vue&type=template&id=b988cd10&scoped=true"
import script from "./selectRooms.vue?vue&type=script&lang=js"
export * from "./selectRooms.vue?vue&type=script&lang=js"
import style0 from "./selectRooms.vue?vue&type=style&index=0&id=b988cd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988cd10",
  null
  
)

export default component.exports